/*
 * Title: Rewards/RedeemContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Redeem Content page content listing, click on list popup will shows from bottom.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React, {Fragment} from "react";
import { motion } from "framer-motion";
import Loader from "@components/Loader";
import { Dialog, Transition } from "@headlessui/react";
import MagicRedeemContentItem from "./MagicRedeemContentItem";
import { connect } from "react-redux";
import Api from "@services/api";
import NotificationService from "@services/notification-service";
import store from "@store/configureStore";
import { Link } from "react-router-dom";


const animations = {
    initial: { opacity: 0, x: 100 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -100 },
};
type Props = {};
type MyState = {
    toggleHeight: boolean;
    redeemed: boolean;
    data:any;
    isOpen:boolean;
    checked:boolean;
    loader:boolean;
    errorMessage:string;
};
class MagicRedeemContent extends React.Component<Props | any, MyState> {
    state: MyState = {
        toggleHeight: false,
        redeemed: true,
        data:{},
        isOpen:false,
        checked:false,
        loader:false,
        errorMessage:""
    };

    toggleHandler = () => {
        this.setState({ toggleHeight: !this.state.toggleHeight });
    };

    fetchRedeemRewards = () => {
        if (this.props.creatorData?.id) {
            this.props.fetchRedeemRewards(this.props.creatorData?.id);
        }
    };

    componentDidUpdate(
        prevProps: Readonly<any>,
        prevState: Readonly<MyState>,
        snapshot?: any
    ): void {
        if (this.props.creatorData?.id != prevProps.creatorData?.id) {
            this.props.fetchRedeemRewards(this.props.creatorData?.id);
            this.props.fetch(this.props.creatorData?.id);
        }
    }

    redeemDrawer = () => {
        let ids = [];
        const available = (this.props.touchpoints?.rewards || []).filter(
            (i) => i.numPurchases != i.reward?.limit
        );
        ids = available.map(i=>i.reward?.id);
        const random = Math.floor(Math.random() * ids.length);
        const datum = (available.filter(
            (i) => i.reward.id == ids[random]
        )?.[0]?.reward || {});
        this.setState({data:datum}, () => {
        if( this.state.data?.id){
            this.setState({isOpen:true, checked:false})
        }
       })
        
        
    }

    closeModal = () => {
        this.setState({isOpen:false})
    }

    purchaseRadeemPoint = async () => {
        const {data}:any = this.state;
        this.setState({ loader: true });
        const json = await Api.purchaseRadeemPoint(
            data?.id,
            this.props.creatorData?.id
            
        );
        if (json.status == 200) {
            store.dispatch({
                type: "UPDATE_SCORES_SUCCESS",
                data: json.data,
            });
            this.closeModal();
            this.fetchRedeemRewards();
        } else {
            NotificationService.error(json?.data?.error?.message);
        }
        this.setState({ loader: false });
    };

    render() {
        const {isOpen, data, errorMessage} = this.state;
        const unavailable = (this.props.touchpoints?.rewards || []).filter(
            (i) => i.numPurchases>0
        );
        const available = (this.props.touchpoints?.rewards || []).filter(
            (i) => i.numPurchases != i.reward?.limit
        );
        
        const {points_redeemed}= this.props;

        const totalPoints = 400;

        const isUnavailable = unavailable.length>0;

        const cname = this.props.creatorData.username
        const pname = this.props.program.name

        return (
            <>
            <div
                className="space-y-3 overflow-y-auto overflow-x-hidden pt-8 px-1 lg:h-[calc(100vh-265px)] lg:pb-[100px] pb-[10px]"
                id="scrollbar"
            >
                <motion.div
                    variants={animations}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    transition={{ duration: 0.5 }}
                >
                    <div>
                        {this.props.isFetching && (
                            <Loader height={30} width={30} white={true} />
                        )}
                            <>
                                {unavailable.length>0 ? (
                                    <div className="text-center mb-6">
                                        <p className="text-[18px] leading-5 font-semibold tile-inlay-primary">
                                            Thank you for participating!
                                        </p>
                                        <p className="text-[14px] leading-4 font-normal tile-inlay-primary pt-2 px-6 opacity-50">
                                            We hope you love your prize and had a blast at Draft Day {new Date().getFullYear()}.
                                        </p>
                                    </div>
                                ) : points_redeemed<totalPoints? (
                                    <div className="text-center mb-6">
                                        <p className="text-[18px] leading-5 font-semibold tile-inlay-primary">
                                            Earn {totalPoints} Points to Collect Your Prize!
                                        </p>
                                        <p className="text-[14px] leading-4 font-normal tile-inlay-primary pt-2 opacity-50">
                                            Once you’ve earned {totalPoints} points, make your way to Guest Services on Terrace Level near sections 111 and 112 to claim your prize, while promotional supplies last.
                                        </p>
                                        <Link
                                            to={`/${cname}/${pname}/earn`}
                                            className="flex mt-4  max-w-[300px] items-center justify-center btn-inlay-primary font-medium lg:text-[18px] text-[16px] bg-btn  rounded-full w-full h-[42px] mx-auto">
                                                earn points
                                        </Link>
                                    </div>
                                ):
                                (
                                    <div className="text-center mb-6">
                                        <p className="text-[18px] leading-5 font-semibold tile-inlay-primary">
                                            You’ve Unlocked Your Prize!
                                        </p>
                                        <p className="text-[14px] leading-4 font-normal tile-inlay-primary pt-2 opacity-50">
                                        Make your way to Guest Services on Terrace Level near sections 111 and 112 to claim one reward of your choice from the list below. Rewards are available while supplies last.
                                        </p>
                                        <p className="text-[14px] leading-4 font-normal tile-inlay-primary pt-4 opacity-50">
                                        Please click the button below only when you’re at Guest Services and ready to collect.
                                        </p>
                                        <button
                                            onClick={this.redeemDrawer}
                                            className="flex mt-4  max-w-[300px] items-center justify-center btn-inlay-primary font-medium lg:text-[18px] text-[16px] bg-btn  rounded-full w-full h-[42px] mx-auto">
                                                redeem
                                        </button>
                                        {/* {!data?.id && errorMessage!="" && <p className="text-[14px] leading-4 font-normal text-red-700 pt-4">{errorMessage}</p>} */}
                                    </div>
                                )}
                                <div className="space-y-[15px] ">
                                    {(available || []).map((reward, key) => {
                                        return (
                                            <MagicRedeemContentItem
                                                fetch={this.fetchRedeemRewards}
                                                creatorId={
                                                    this.props.creatorData.id
                                                }
                                                item={reward}
                                                selected={data}
                                                key={key}
                                                points_redeemed={
                                                    this.props.points_redeemed
                                                }
                                                selectitem={(data)=>this.setState({data:data})}
                                                isUnavailable={unavailable.length>0}
                                                redeemDrawer={this.redeemDrawer}
                                            />
                                        );
                                    })}
                                </div>

                               
                            </>
                    </div>
                </motion.div>
            </div>
            <Transition
                            appear
                            show={isOpen}
                            as={Fragment}
                        >
                            <Dialog
                                as="div"
                                className="relative z-50"
                                onClose={this.closeModal}
                            >
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                   <div className="fixed inset-0 bg-black bg-opacity-80 transition-opacity" />
                                </Transition.Child>

                                <div className={`fixed inset-0 overflow-hidden`}>
                                    <div className="absolute inset-0 overflow-hidden">
                                        <div className="fixed inset-x-0 bottom-0 flex items-end justify-center min-h-full text-center">
                                            <Transition.Child
                                                as={Fragment}
                                                enter="transform transition ease-in-out duration-700"
                                                enterFrom="translate-y-full"
                                                enterTo="translate-y-0"
                                                leave="transform transition ease-in-out duration-700"
                                                leaveFrom="translate-y-0"
                                                leaveTo="translate-y-full"
                                            >
                                                <Dialog.Panel className="w-screen max-w-[685px] transform overflow-hidden rounded-b-none rounded-t-[40px] text-left align-middle shadow-xl transition-all bg-[#1D1D1D]">
                                                    <div className="relative">
                                                        <button
                                                            type="button"
                                                            className="text-white rounded-md outline-none hover:text-white hover:opacity-70"
                                                            onClick={
                                                                this.closeModal
                                                            }
                                                        >
                                                            <span className="sr-only">
                                                                Close panel
                                                            </span>
                                                            <div className="w-[25px] h-1 absolute mx-auto top-[10px] left-0 right-0 bottom-0 rounded-full bg-lightBlack"></div>
                                                        </button>
                                                    </div>
                                                    <div className="px-[30px] text-center">
                                                        <h3 className="tile-inlay-primary font-[550] text-[24px] leading-[31px] mt-[41px]">
                                                            Are you sure you want to
                                                            redeem this reward?
                                                        </h3>
                                                        <p className="mt-[15px] text-[18px] font-normal leading-[22px] tile-inlay-primary opacity-50">
                                                            Please only confirm
                                                            below if you are at the
                                                            prize booth and ready to
                                                            collect your reward in
                                                            person. Once you
                                                            confirm, you will not be
                                                            able to collect another
                                                            reward.
                                                        </p>
                                                        <div className="flex items-center justify-center mt-7 gap-3">
                                                            <label
                                                                htmlFor="redeem"
                                                                className="cursor-pointer flex items-center text-[15px] font-normal"
                                                            >
                                                                <input
                                                                    id="redeem"
                                                                    type="checkbox"
                                                                    className="hidden peer"
                                                                    onChange={(e)=>this.setState({checked:e.target.checked})}
                                                                />
                                                                <span className="peer-checked:bg-[#fff] bg-transparent h-[16px] w-[16px] before:content-[''] relative before:absolute before:bottom-[4.2px] before:left-[1.1px] before:h-[5px] before:w-[10px] before:border-b-2 before:border-l-2 before:-rotate-[45deg] peer-checked:before:border-[#4c4c4c] before:border-transparent inline-block border-2 rounded-[4px]"></span>
                                                            </label>
                                                            <h6 className="tile-inlay-primary text-[16px] leading-[19px] font-semibold">
                                                                I’m ready to collect
                                                                my reward.
                                                            </h6>
                                                        </div>
                                                        <div className="relative mb-4">
                                                        
                                                            <button   
                                                                disabled={!this.state.checked}
                                                                onClick={this.purchaseRadeemPoint} 
                                                                className={`mt-6 ${!this.state.checked?"bg-[#434040]":"bg-btn"} text-center max-w-[300px] w-full mx-auto rounded-full`}>
                                                                {this.state.loader?
                                                                <Loader height={30} width={30} white={true} />:
                                                                <div
                                                                
                                                                    className={`font-medium text-[18px] leading-[18px] btn-inlay-primary py-3 px-9`}
                                                                >redeem now</div>
                                                                }
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Dialog.Panel>
                                            </Transition.Child>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>
                        </Transition>
            </>
        );
    }
}

const mapStateToProps = ({ creator, RedeemReward, score, user }) => {
    return {
        creatorData: creator?.creator,
        program: creator?.program,
        assets: creator.assets,
        touchpoints: RedeemReward.data,
        isFetching: RedeemReward.isFetching,
        points_redeemed: score.points_redeemed,
    };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
    const { dispatch } = dispatchProps;
    const { redeemRewardActions } = require("@redux/RedeemRewardRedux");
    return {
        ...stateProps,
        fetchRedeemRewards: (creatorId) => {
            redeemRewardActions.fetchRedeemRewards(dispatch, creatorId);
        },
    };
};

export default connect(
    mapStateToProps,
    undefined,
    mergeProps
)(MagicRedeemContent);
